import { render, staticRenderFns } from "./DataSlider.vue?vue&type=template&id=f8b5d0f4"
import script from "./DataSlider.vue?vue&type=script&lang=js"
export * from "./DataSlider.vue?vue&type=script&lang=js"
import style0 from "./DataSlider.vue?vue&type=style&index=0&id=f8b5d0f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports